import styled from 'styled-components';
import { RadioInput } from '@app/src/common/RadioInput';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { withShimmer } from '@app/src/common/withShimmer';

export const RadioInputWrapper = styled(RadioInput)`
  align-items: flex-start;
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const Option = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin-left: 6px;
`;

export const Title = styled.span`
  font-size: 16px;
  color: ${COLORS.BLACK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-weight: 600;
  }
`;

export const Description = styled.p`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.GRAY_DARK};
  font-size: 12px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const IconWrapper = styled.span`
  width: 23px;
  margin: 8px 0 0 6px;
`;

export const OptionShimmer = styled.div`
  display: flex;
  &:not(last-child) {
    margin-bottom: 11px;
  }
`;

export const CircleShimmer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  margin-top: 11px;
  margin-right: 6px;
  overflow: hidden;
`;

export const DetailShimmer = styled.div`
  width: 100%;

  @medias (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 400px;
  }
`;

export const TitleShimmer = styled.div`
  width: 85px;
  height: 18px;
`;

export const DescriptionShimmer = styled.div`
  height: 13px;
  margin-top: 8px;
  width: 100%;
`;

export const WrapperShimmer = styled.div`
  min-height: 50px;
  width: 100%;
`;

export const Shimmer = withShimmer()(styled.div``);